/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getQuestionNotPassMessageDetail = params => {
  return axios.get(`${base}/get_batch_error_msg/${params.batch_id}`, {params})
}
export const saveQuestionNotPassMessageData = params => {
  return axios.post(`${base}/save_batch_error_msg/${params.batch_id}`, params)
}

export const saveBatchErrorMsgMultiple = params => {
  return axios.post(`${base}/save_batch_error_msg_multiple`, params)
}



// WEBPACK FOOTER //
// ./src/views/question-error-message/question-error-message.api.js